export default "__VITE_ASSET__DXF6cR5R__"